/**
 * @wlh/validation — zod schemas used to validate every API input server-side
 * (Master Brief §16.9) and shared with the web app for client-side pre-checks.
 *
 * Day 1 scope: the health response and the four inbound bridge events. The
 * bridge schemas are the security boundary for HTML packages — see
 * docs/html-package-bridge.md.
 */
import { z } from "zod";
export const bridgeVersionSchema = z.literal("1.0");
const guestEnvelope = {
    bridgeVersion: bridgeVersionSchema,
    sessionToken: z.string().min(1).max(4096),
    eventId: z.string().uuid(),
};
export const moduleStartedSchema = z.object({
    type: z.literal("MODULE_STARTED"),
    ...guestEnvelope,
});
export const progressUpdatedSchema = z.object({
    type: z.literal("PROGRESS_UPDATED"),
    ...guestEnvelope,
    percent: z.number().min(0).max(100),
    currentSection: z.string().max(200).optional(),
});
export const stateSaveSchema = z.object({
    type: z.literal("STATE_SAVE"),
    ...guestEnvelope,
    // Opaque resume blob. Hard cap to keep a package from using the LMS as storage.
    payload: z.string().max(64 * 1024),
});
export const moduleCompletedSchema = z.object({
    type: z.literal("MODULE_COMPLETED"),
    ...guestEnvelope,
});
export const guestBridgeMessageSchema = z.discriminatedUnion("type", [
    moduleStartedSchema,
    progressUpdatedSchema,
    stateSaveSchema,
    moduleCompletedSchema,
]);
export const healthResponseSchema = z.object({
    status: z.literal("ok"),
    service: z.literal("withawill-learning-hub-api"),
    version: z.string(),
    commit: z.string(),
    time: z.string(),
});
export * from "./authoring.js";
export * from "./invitations.js";
export * from "./organisations.js";
export * from "./assessment.js";
export * from "./certificate.js";
export * from "./diagnostic.js";
export * from "./feedback.js";
//# sourceMappingURL=index.js.map